import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';
import { remove as removeDiac } from 'diacritics';

import { SelectedEntityState } from '../../../../shared/store/selected-entity.feature';
import { Livrable } from '../models/livrable.model';
import { LivrableState } from './livrable.state';

type State = LivrableState & EntityState<Livrable> & SelectedEntityState;
type Props = EntityProps<Livrable> & { selectedEntity: Signal<Livrable | null> };

export function avecSélecteursLivrables<_>() {
  return signalStoreFeature(
    {
      state: type<State>(),
      props: type<Props>(),
    },
    withComputed(({ filtre, entities }) => ({
      livrablesFiltrés: computed(() =>
        entities().filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
    })),
  );
}
